module.exports = __webpack_public_path__ + "static/media/shareworks.ae457c55.png";